export default "__VITE_ASSET__CXQulZvN__"